var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4844 2.39126L10.9613 2.90688L11.477 2.39212C12.9164 0.989189 14.9102 0.350673 16.8695 0.676806C19.8301 1.17009 22 3.73188 22 6.7354V6.98462C22 8.76782 21.2609 10.4737 19.9547 11.6897L12.1902 18.9385C11.868 19.2393 11.4426 19.4069 11 19.4069C10.5574 19.4069 10.132 19.2393 9.80977 18.9385L2.04488 11.6897C0.740352 10.4737 0 8.76782 0 6.98462V6.7354C0 3.73188 2.17078 1.17009 5.13047 0.676806C7.05117 0.350673 9.08359 0.989189 10.4844 2.39126C10.4844 2.39169 10.4457 2.39126 10.4844 2.39126ZM10.9613 5.82446L9.02773 3.81352C8.09531 2.91892 6.77187 2.49438 5.46992 2.71095C3.5041 3.0388 2.0625 4.74165 2.0625 6.7354V6.98462C2.0625 8.19634 2.56566 9.35649 3.45211 10.1815L11 17.2284L18.5496 10.1815C19.4348 9.35649 19.9375 8.19634 19.9375 6.98462V6.7354C19.9375 4.74165 18.4937 3.0388 16.5301 2.71095C15.2281 2.49438 13.9047 2.91892 12.9723 3.81352L10.9613 5.82446Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRegular);
export default __webpack_public_path__ + "static/media/heart-regular.8695f3fa8c30986193b0be3df975fb87.svg";
export { ForwardRef as ReactComponent };